<template>
  <div id="interview-change-pay-suc">
    <img :src="$importImage('insurance/insurance-success.png')" alt="">
    <div>支付成功</div>
    <div>成功申请修改赴馆时间，签证专家将于 2 个工作日内帮您重新预约。请留意短信及微信通知：）</div>
    <button @click="$router.push({name:'orderDetail',params: {oid: $route.params.oid}})">查看订单</button>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {},
  created() {},
};
</script>

<style lang="less" scoped>
@import '../assets/less/variable.less';
#interview-change-pay-suc {
  margin-top: 20px !important;
  width: 1000px;
  height: 550px;
  margin: auto;
  padding-bottom: 100px;
  background: #ffffff;
  text-align: center;
  div {
    margin: auto;
  }
  img {
    width: 110px;
    height: 90px;
    margin-top: 110px !important;
  }
  div:nth-of-type(1) {
    font-size: 26px;
    color: #333333;
    margin-top: 24px;
  }
  div:nth-of-type(2) {
    line-height: 32px;
    width: 324px;
    color: #777777;
    font-size: 14px;
    margin-top: 17px;
  }
  button {
    width: 300px;
    height: 40px;
    background-color: #5e9be1;
    border-radius: 4px;
    border: 0;
    color: #ffffff;
    font-size: 16px;
    margin-top: 20px;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/InterViewChangePaySuc.vue